import { Component, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { TabsModule } from 'primeng/tabs';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { MatIconModule } from '@angular/material/icon';
import { SectionService } from '../../../../services/builder/section.service';
import { UniqueIdService } from '../../../../services/builder/unique-id.service';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'lib-section-customization-panel',
  template: `
    <div
      [formGroup]="customizationForm"
      class="flex h-full w-full flex-col gap-4 overflow-hidden"
    >
      <p-tabs [value]="0">
        <p-tablist>
          <p-tab [value]="0">Impostazioni base</p-tab>
          <p-tab [value]="1">Impostazioni avanzate</p-tab>
        </p-tablist>
        <p-tabpanels>
          <p-tabpanel [value]="0" class="overflow-hidden">
            <div class="tab-panel h-120 flex flex-col gap-4">
              <div class="flex flex-row gap-2">
                <div class="flex w-full flex-col">
                  <label for="desc">Titolo</label>
                  <input id="desc" pInputText formControlName="title" />
                </div>
              </div>
              <div class="flex flex-row gap-2">
                <div class="flex w-full flex-col">
                  <label for="desc">Sottotitolo</label>
                  <input id="desc" pInputText formControlName="subTitle" />
                </div>
              </div>
              <div class="flex flex-row gap-2">
                <div class="flex w-full flex-col">
                  <label for="desc">Descrizione</label>
                  <input id="desc" pInputText formControlName="description" />
                </div>
              </div>
              <div class="flex flex-row gap-2">
                <div class="flex w-full flex-col">
                  <label for="points">Punti ottenibili nella sezione</label>
                  <p-inputnumber
                    [autofocus]="false"
                    formControlName="points"
                  ></p-inputnumber>
                </div>
              </div>
            </div>
          </p-tabpanel>
          <p-tabpanel [value]="1" class="overflow-hidden">
            <div class="tab-panel h-120 flex flex-col gap-4">
              <div class="flex flex-col">
                <label for="id">Scegli ID</label>
                <input
                  id="id"
                  type="text"
                  pInputText
                  formControlName="id"
                  pKeyFilter="alphanum"
                />
                @if (customizationForm.controls.id.hasError('forbiddenId')) {
                  <div class="text-red-500">Hai già usato questo alias</div>
                }
                @if (customizationForm.controls.id.hasError('required')) {
                  <div class="text-red-500">Il campo è obbligatorio</div>
                }
              </div>
            </div>
          </p-tabpanel>
        </p-tabpanels>
      </p-tabs>
      <div class="footer-bar flex w-full flex-row justify-end gap-2">
        <p-button
          (click)="updateSection(false)"
          [fluid]="true"
          [text]="true"
          class="w-30"
        >
          Annulla
        </p-button>
        <p-button
          (click)="updateSection(true)"
          [fluid]="true"
          class="w-30"
          cdkFocusInitial
        >
          Conferma
        </p-button>
      </div>
    </div>
  `,
  imports: [
    TabsModule,
    ReactiveFormsModule,
    InputTextModule,
    InputNumberModule,
    MatIconModule,
    ButtonModule,
  ],
})
export class SectionCustomizationPanelComponent {
  private fb = inject(FormBuilder);
  protected sectionService = inject(SectionService);
  private uniqueIdService = inject(UniqueIdService);

  customizationForm = this.fb.group({
    id: [
      '',
      [
        Validators.required,
        this.uniqueIdService.forbiddenIdValidator(
          this.sectionService.uniqueId ?? '',
        ),
        this.uniqueIdService.isEmptySpace(),
      ],
    ],
    title: ['', [Validators.required]],
    subTitle: [''],
    description: [''],
    points: [0, [Validators.min(0)]],
  });

  constructor() {
    const section = this.sectionService.section();
    if (!section) return;

    const uniqueId = this.sectionService.uniqueId;
    if (!uniqueId) return;

    this.customizationForm.patchValue({
      id: uniqueId,
      description: section.customization.description || '',
      title: section.customization.title || '',
      subTitle: section.customization.subTitle || '',
      points: section.customization.points || 0,
    });
  }

  updateSection(success: boolean) {
    if (!success) {
      this.sectionService.sectionCustomizationVisible.set(false);
      return;
    }

    const formValue = this.customizationForm.value;
    const id = formValue.id;
    if (!id) return;

    this.sectionService.updateSection(id, {
      title: formValue.title ?? '',
      subTitle: formValue.subTitle ?? '',
      description: formValue.description ?? '',
      points: formValue.points ?? 0,
    });
    this.sectionService.sectionCustomizationVisible.set(false);
  }
}
